import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#556689",
        secondary: "#8E258D",
        accent: "#A7A8AA",
        error: "#D52B1E",
        warning: "#E98300",
        info: "#009FDA",
        success: "#38B233"
      },
      dark: {
        primary: "#556689",
        secondary: "#8E258D",
        accent: "#A7A8AA",
        error: "#D52B1E",
        warning: "#E98300",
        info: "#009FDA",
        success: "#38B233"
      }
    },
    options: {
      customProperties: true,
    }
  }
});
